// extracted by mini-css-extract-plugin
export default {"background":"Shared_background__P26zm","logo":"Shared_logo__duWKB"};